import { ReactElement } from "react";
import { components } from "react-select";
import { AsyncProps as RSAsyncProps } from "react-select/src/Async";
import {
  IndicatorProps as RSIndicatorProps,
  LoadingIconProps as RSLoadingIconProps,
} from "react-select/src/components/indicators";
import {
  MenuListComponentProps as RSMenuListComponentProps,
  MenuProps as RSMenuComponentProps,
} from "react-select/src/components/Menu";
import { MultiValueProps as RSMultiValueProps } from "react-select/src/components/MultiValue";
import { OptionProps as RSOptionComponentProps } from "react-select/src/components/Option";
import { SingleValueProps as RSSingleValueComponentProps } from "react-select/src/components/SingleValue";
import { CreatableProps as RSCreatableProps } from "react-select/src/Creatable";
import { Option as RSFilterOption } from "react-select/src/filters";
import { Props as RSProps } from "react-select/src/Select";

import { ITestable } from "@/browser";

import { IBlurable, IStyleBasicProps } from "../../types";

export const SELECT_CLASS_NAME = "el-form-select-next";

export interface IGenericChangeable<T = any> {
  value?: T | null;
  onChange?: (value: T | null) => void;
}

type TReactSelectProps =
  | "className"
  | "components"
  | "controlShouldRenderValue"
  | "delimiter"
  | "filterOption"
  | "formatOptionLabel"
  | "hideSelectedOptions"
  | "isClearable"
  | "isSearchable"
  | "isDisabled"
  | "isLoading"
  | "isMulti"
  | "noOptionsMessage"
  | "onInputChange"
  | "onKeyDown"
  | "onMenuClose";

interface IReactSelectProps<T = any> extends Pick<RSProps<T>, TReactSelectProps> {}

export interface ISelectFilterOption<T = any> extends RSFilterOption {
  data: T;
}

export interface ISelectIcons {
  clear: ReactElement;
  dropdownMenuOpen: ReactElement;
  dropdownMenuClosed: ReactElement;
}

export interface ISelectProps<T = any>
  extends IReactSelectProps<T>,
    IBlurable,
    IGenericChangeable<T>,
    IStyleBasicProps,
    ITestable {
  icons?: Partial<ISelectIcons>;
  labelKey?: string | ((option: T) => string);
  options?: T[];
  valueKey?: string;

  // IInputBasicProps
  name?: string;
  className?: string;
  placeholder?: string;
  readonly?: boolean;
  required?: boolean;
  touched?: boolean;
  invalid?: boolean;
  autoComplete?: any;
  isCreatable?: boolean;
}

interface ILoadableInputProps<T = any> extends RSAsyncProps<T> {}
interface ICreatableInputProps<T = any> extends RSCreatableProps<T> {}

export interface ITypeaheadProps<T = any> extends ISelectProps<T>, ICreatableInputProps<T>, ILoadableInputProps<T> {
  autoload?: boolean;
  debounceTime?: number;
  isCreatable?: boolean;
}

// COMPONENTS API

export { components as ReactSelectComponents };

export interface ISelectIndicatorProps<T> extends RSIndicatorProps<T> {}
export interface ISelectLoadingIconComponentProps<T> extends RSLoadingIconProps<T> {}
export interface ISelectMenuComponentProps<T> extends RSMenuComponentProps<T> {}
export interface ISelectMenuListComponentProps<T> extends RSMenuListComponentProps<T> {}
export interface ISelectMultiValueComponentProps<T> extends RSMultiValueProps<T> {}
export interface ISelectOptionComponentProps<T> extends RSOptionComponentProps<T> {
  data: T;
}
export interface ISelectSingleValueComponentProps<T> extends RSSingleValueComponentProps<T> {}
